// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27currentColor%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpolyline points=%276 9 12 15 18 9%27%3e%3c/polyline%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Pagination styles */
.news-pagination {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    background-color: #f8fafc;
    border-top: 1px solid #e5e7eb;
    margin-top: 1px;
}

.news-pagination-rows-per-page {
    display: flex;
    align-items: center;
    gap: 12px;
}

.news-pagination-rows-per-page-label {
    font-size: 14px;
    color: #64748b;
}

.news-pagination-rows-per-page-select {
    padding: 4px 24px 4px 8px;
    border: 1px solid #e2e8f0;
    border-radius: 4px;
    background-color: white;
    font-size: 14px;
    color: #1e293b;
    cursor: pointer;
    outline: none;
    appearance: none;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right 8px center;
    background-size: 12px;
}

.news-pagination-controls {
    display: flex;
    align-items: center;
    gap: 8px;
}

.news-pagination-button {
    padding: 4px 8px;
    border: 1px solid #e2e8f0;
    border-radius: 4px;
    background-color: white;
    color: #1e293b;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.2s ease;
}

.news-pagination-button:hover {
    background-color: #f1f5f9;
    border-color: #cbd5e1;
}

.news-pagination-button:disabled {
    cursor: not-allowed;
    opacity: 0.5;
    background-color: #f8fafc;
}

.news-pagination-info {
    font-size: 14px;
    color: #64748b;
    padding: 0 8px;
    min-width: 120px;
    text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/styles/NewsTablePagination.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,yDAA2R;IAC3R,4BAA4B;IAC5B,qCAAqC;IACrC,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB","sourcesContent":["/* Pagination styles */\n.news-pagination {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 16px;\n    background-color: #f8fafc;\n    border-top: 1px solid #e5e7eb;\n    margin-top: 1px;\n}\n\n.news-pagination-rows-per-page {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.news-pagination-rows-per-page-label {\n    font-size: 14px;\n    color: #64748b;\n}\n\n.news-pagination-rows-per-page-select {\n    padding: 4px 24px 4px 8px;\n    border: 1px solid #e2e8f0;\n    border-radius: 4px;\n    background-color: white;\n    font-size: 14px;\n    color: #1e293b;\n    cursor: pointer;\n    outline: none;\n    appearance: none;\n    background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e\");\n    background-repeat: no-repeat;\n    background-position: right 8px center;\n    background-size: 12px;\n}\n\n.news-pagination-controls {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.news-pagination-button {\n    padding: 4px 8px;\n    border: 1px solid #e2e8f0;\n    border-radius: 4px;\n    background-color: white;\n    color: #1e293b;\n    cursor: pointer;\n    font-size: 14px;\n    transition: all 0.2s ease;\n}\n\n.news-pagination-button:hover {\n    background-color: #f1f5f9;\n    border-color: #cbd5e1;\n}\n\n.news-pagination-button:disabled {\n    cursor: not-allowed;\n    opacity: 0.5;\n    background-color: #f8fafc;\n}\n\n.news-pagination-info {\n    font-size: 14px;\n    color: #64748b;\n    padding: 0 8px;\n    min-width: 120px;\n    text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
